import { createBrowserRouter } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { DashboardPage } from "@/pages/DashboardPage";
import { InboxPage } from "@/pages/InboxPage";
import { ContactsPage } from "@/pages/ContactsPage";
import { ContactDetailPage } from "@/pages/ContactDetailPage";
import { VisitsPage } from "@/pages/VisitsPage";
import { NotificationsPage } from "@/pages/NotificationsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { PropertiesPage } from "@/pages/PropertiesPage";
import { KnowledgePage } from "@/pages/KnowledgePage";
import { ConnectionsPage } from "@/pages/ConnectionsPage";
import { BusinessPage } from "@/pages/BusinessPage";
import { BusinessBrainPage } from "@/pages/BusinessBrainPage";
import { AIBotPage } from "@/pages/AIBotPage";
import { ActivityLogPage } from "@/pages/ActivityLogPage";
import { TemplatesPage } from "@/pages/TemplatesPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "inbox", element: <InboxPage /> },
      { path: "contacts", element: <ContactsPage /> },
      { path: "contacts/:id", element: <ContactDetailPage /> },
      { path: "properties", element: <PropertiesPage /> },
      { path: "knowledge", element: <KnowledgePage /> },
      { path: "business-brain", element: <BusinessBrainPage /> },
      { path: "business", element: <BusinessPage /> },
      { path: "ai-bot", element: <AIBotPage /> },
      { path: "connections", element: <ConnectionsPage /> },
      { path: "activity", element: <ActivityLogPage /> },
      { path: "visits", element: <VisitsPage /> },
      { path: "notifications", element: <NotificationsPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "templates", element: <TemplatesPage /> },
    ],
  },
]);
